import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const LeftChevronComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="nostra__icon nostra__icon__leftChevron"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path d="M10 4L6 8L10 12" stroke={colorVar} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const LeftChevron = withIcon(LeftChevronComponent);
